import type { TCreateDealPayload } from '../model/form.schema';

const appendOptionalField = (
    formData: FormData,
    name: string,
    value: string | number | null | undefined
) => {
    if (value === null || value === undefined || value === '') {
        return;
    }

    formData.append(name, String(value));
};

export const createDealFormDataAdapter = (data: TCreateDealPayload, defaultDealName: string) => {
    const formData = new FormData();

    formData.append('customer_name', data.customerName);
    formData.append('name', data.dealName?.trim() || defaultDealName);
    appendOptionalField(formData, 'column_id', data.columnId);

    appendOptionalField(formData, 'received_at', data.receivedAt);
    appendOptionalField(formData, 'phone', data.phone);
    appendOptionalField(formData, 'object_type', data.objectType);
    appendOptionalField(formData, 'area', data.areaSquare);
    appendOptionalField(formData, 'request_essence', data.description);
    appendOptionalField(formData, 'approximate_budget', data.budget);
    appendOptionalField(formData, 'source', data.source);

    return formData;
};
